import { m } from '@hub/messages';
import { HomePaths } from '../../domains/home/route.paths';
import { AuthLayout } from '../../layout/AuthLayout';
import { createRoute } from '..';
import { layoutRouteId } from '../definePath';
import { Route as rootRoute } from './__root';
import { type AuthenticatedGuard, composeAuthenticatedBeforeLoad } from './_authenticated.guard';

// Single source of the layout id; router.tsx derives the routeId from it.
export const AUTHENTICATED_LAYOUT_ID = layoutRouteId('authenticated');

export function createAuthenticatedRoute(extraGuards: readonly AuthenticatedGuard[]) {
  return createRoute({
    id: AUTHENTICATED_LAYOUT_ID,
    getParentRoute: () => rootRoute,
    staticData: {
      breadcrumbLabel: () => m.commons_nav_overview(),
      breadcrumbPath: HomePaths.home.path,
    },
    beforeLoad: composeAuthenticatedBeforeLoad(extraGuards),
    // Prevent the layout shell from unmounting during child route suspense;
    // only the child route should show a pending skeleton, not the entire page.
    wrapInSuspense: false,
    component: AuthLayout,
  });
}
